import React from 'react';
import { type PropsWithChildren } from 'react';

import { DisplayText } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuDietaryPreferencesHeading = (props: PropsWithChildren) => {
  const { children } = props;

  return <DisplayText sizeMatch={['32']}>{children}</DisplayText>;
};
